import { useMutation } from 'react-query'
import { useNavigate, useParams } from 'react-router-dom'

import AuthDataService from 'src/services/auth.service'

import { joinAbsRoute } from 'src/common/utils'
import { ROUTES, STORAGE_KEYS } from 'src/constants'

const useSignUpEmailVerification = () => {
  const { token } = useParams()
  const navigate = useNavigate()

  const referrerId = localStorage.getItem(STORAGE_KEYS.REFERRAL_ID)

  return useMutation(
    (code: string) => AuthDataService.verifySignUpEmail(token!, code, referrerId),
    {
      onSettled: (data) => {
        if (!data) return

        if (localStorage.getItem(STORAGE_KEYS.REFERRAL_ID)) {
          localStorage.removeItem(STORAGE_KEYS.REFERRAL_ID)
        }

        if (data.journeyRedirect) {
          ;((redirect: string) => {
            setTimeout(() => {
              window.location.replace(redirect)
            }, 1000)
          })(data.journeyRedirect)

          return
        }

        if (data.accessToken && data.refreshToken) {
          localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, data.accessToken)
          localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, data.refreshToken)

          return navigate(
            data?.customer
              ? joinAbsRoute(ROUTES.USER, ROUTES.USER_DASHBOARD)
              : data.accountId
                ? joinAbsRoute(ROUTES.ACCOUNTS, data.accountId, ROUTES.DASHBOARD)
                : data.scannerAccountId
                  ? joinAbsRoute(ROUTES.ACCOUNTS, data.scannerAccountId, ROUTES.SCAN_HISTORY)
                  : joinAbsRoute(ROUTES.ACCOUNTS),
            { replace: true },
          )
        }

        if (!data.agreement) {
          return navigate(`${ROUTES.REGISTER_FINISH}?userId=${data.id}&email=${data.email}`)
        }
      },
    },
  )
}

export { useSignUpEmailVerification }
